export type MerchflowsMultiValue<T extends string = string> = T | readonly T[] | undefined;

export const normalizeMultiValue = <T extends string>(values: MerchflowsMultiValue<T>) => {
  const candidateValues =
    values === undefined ? undefined : Array.isArray(values) ? values : [values];

  if (!candidateValues?.length) {
    return undefined;
  }

  const normalizedValues = candidateValues
    .map((value) => value.trim())
    .filter((value): value is T => value !== "")
    .filter((value, index, array) => array.indexOf(value) === index);

  return normalizedValues.length > 0 ? normalizedValues : undefined;
};
